import React from 'react';
import { BlockList } from '@udemy/react-core-components';
import { BrowseNavItem } from '../../desktop/browse/browse-nav.react-component';
import styles from "../../desktop/list-menu.module.css";
import { useBrowseNavStore } from '../../hooks/use-browse-nav-store';
export const BrowseNavCustomCategories = () => {
  var _browseNavStore$selec;
  const browseNavStore = useBrowseNavStore();
  return /*#__PURE__*/React.createElement(BlockList, {
    size: "small",
    className: styles['section'],
    iconAlignment: "right"
  }, (_browseNavStore$selec = browseNavStore.selectedLevelOneItem) === null || _browseNavStore$selec === void 0 || (_browseNavStore$selec = _browseNavStore$selec.children) === null || _browseNavStore$selec === void 0 ? void 0 : _browseNavStore$selec.map(item => /*#__PURE__*/React.createElement(BrowseNavItem, {
    key: item.id,
    navItem: item,
    id: `header-browse-nav-${item.type}-${item.id}`
  })));
};
//# sourceMappingURL=browse-nav-custom-categories.react-component.js.map